import React, {Component} from 'react';
import { Link } from 'react-router-dom';
import jsxToString from 'jsx-to-string';
import ReactHtmlParser from 'react-html-parser';
import { FaPlus } from 'react-icons/fa';
import {FeedingController} from '../controllers/Feeding';
import FeedingResults from './FeedingResults';
import BreastFedModal from "./BreastFedModal";
import MealFedModal from "./MealFedModal";
import Menu from "./Menu";
// import {
//   Button,
//   Modal,
//   ModalHeader,
//   ModalBody,
//   ModalFooter,
//   Form,
//   FormGroup,
//   Input,
//   Label
// } from "reactstrap";
import '../styles/feeding.css';


export const FeedingForm  = class FeedingForm extends Component {
  constructor() {
    super();
    this.state = {
      breastFedModal: false,
      breast_frequency: null,
      mealFedModal: false,
      submitted: false,
      onlyBreastFed: false,
      meal_food_list: null,
      meal_menu: [],
      feeding_options: {
        breast_feeding: null,
        breast_frequency: null,
        meal_feeding: null,
      }
    };
  }

  initializeData = () => {
    const state = this.state
    state.feeding_options.breast_feeding = this.props.Translator['feeding_practice_breastfeed_option_placeholder'];
    state.feeding_options.breast_frequency = this.props.Translator['feeding_practice_breastfeed_frequency_placeholder'];
    state.feeding_options.meal_feeding = this.props.Translator['feeding_practice_mealfeed_option_placeholder'];
    state.meal_food_list = this.props.Translator['feeding_practice_mealfeed_value_placeholder'];
    this.setState(state);
  }

  // onChange = (e) => {
  //   const state = this.state
  //   state[e.target.name] = e.target.value;
  //   this.setState(state);

  // }

  validateInputs = () => {

    const state = this.state;
    const {breast_feeding, breast_frequency, meal_feeding} = state.feeding_options;
    const {meal_menu} = state;
    const translation = this.props.Translator;
    var error = false;
    if (breast_feeding == translation['feeding_practice_breastfeed_option_placeholder']){
      state.breast_feeding_error = jsxToString(<font style={{color:"#ff0000", fontSize:"0.9em"}}>{translation['feeding_practice_breastfeed_option_error']}</font>);
      error = true;
    }
    else if (breast_feeding == "Yes" || breast_feeding == "Ndiyo"){
      state.breast_feeding_error = null;
      if (breast_frequency == translation['feeding_practice_breastfeed_frequency_placeholder']){
        state.breast_frequency_error = jsxToString(<font style={{color:"#ff0000", fontSize:"0.9em"}}>{translation['feeding_practice_breastfeed_frequency_error']}</font>);
        error = true;
      }
      else
        state.breast_frequency_error = null;
    }
    
    if (meal_feeding == translation['feeding_practice_mealfeed_option_placeholder']){
      state.meal_feeding_error =jsxToString(<font style={{color:"#ff0000", fontSize:"0.9em"}}>{translation['feeding_practice_mealfeed_option_error']}</font>);
      error = true;
    }
    else if (meal_feeding == "Yes" || meal_feeding == "Ndiyo"){
      state.meal_feeding_error = null;
      if ( meal_menu.length === 0)
      {
        state.feeding_error = jsxToString(<font style={{color:"#ff0000", fontSize:"0.9em"}}>{translation['feeding_practice_mealfeed_value_error']}</font>);
        error = true;
      }
      else{
        state.feeding_error = null;
      }
    }
    
    if(error){
      state.feeding_info_error = jsxToString(<font style={{color:"#ff0000", fontSize:"1em"}}>{translation['feeding_practice_main_error']}</font>);
      this.setState({state});
      return false;
    }
    else{
      if ((meal_feeding == "No" || meal_feeding == "Hapana") && (breast_feeding == "No" || breast_feeding == "Hapana")) {
        alert(translation['feeding_practice_breastfeed_no_choice_error_a']+'\n'+translation['feeding_practice_breastfeed_no_choice_error_b']);
        this.setState({state});
        return false
      }
      else if (meal_feeding == "No" || meal_feeding == "Hapana") {
        state.onlyBreastFed = true;
        this.setState({state});
        return true;
      }
      else {
        this.setState({state});
        return true;
      }
    }
  }



  onSubmit = (e) => {
    if(this.validateInputs())
      this.setState({submitted: true});
    else
      this.setState({submitted: false});
  }

  onBreastFed= () => {
    this.setState({ breastFedModal: !this.state.breastFedModal });
  }

  onMealFed= () => {
    this.setState({ mealFedModal: !this.state.mealFedModal });
  }

  onBreastFrequencySave= (data) => {
    const state = this.state
    if(data.breast_feeding == "Hapana" || data.breast_feeding == "Hapana"){
      state.feeding_options.breast_feeding = data.breast_feeding;
      state.feeding_options.breast_frequency = this.props.Translator['feeding_practice_breastfeed_frequency_placeholder'];
    }
    else{
      if(data.breast_feeding !== null)
        state.feeding_options.breast_feeding = data.breast_feeding;
      if(data.breast_frequency!== null)
        state.feeding_options.breast_frequency= data.breast_frequency;
    }

    this.setState(state);
    this.onBreastFed();
  }

  onMealFoodListSave= (data) => {
    const state = this.state
    if(data.meal_feeding == "No" || data.meal_feeding == "Hapana"){
      state.feeding_options.meal_feeding = data.meal_feeding;
      state.meal_food_list = this.props.Translator['feeding_practice_mealfeed_value_placeholder'];
    }
    else{
      if(data.meal_feeding !== null)
        state.feeding_options.meal_feeding = data.meal_feeding;
      if(data.meal_food_list!== null){
        state.meal_menu = data.meal_food_list;
        const food_names = data.meal_food_list.map((food) => {
          return food.label;
        }).join(', ');
        state.meal_food_list = food_names;
      }
    }

    this.setState(state);
    this.onMealFed();
  }

  componentDidMount() {
    this.initializeData();
    this.props.showFeedingInst(true);
  }

  render() {
    const { Translator, Child, User, age} = this.props;
    const translation = this.props.Translator;

    return (
      <div className='h-100'>
        {!this.state.submitted ? (
          <div className="col-sm-12 col-md-12 col-xs-12" style={{padding: "0px",height: "100%",overflowY: "scroll",overflowX: "hidden"}}>
            <body style={{backgroundColor: "#d3d3d3"}}>
              <div className="container-fluid" style={{padding: "0px"}}>
                <div className="col-md-12 col-sm-12 col-xs-12" id="feeding_form" style={{padding: "0px",backgroundColor: "#fff",display: "",marginTop: "20px",fontSize: "0.8em"}}>
              
                  <div>
                    {/* <div className="card-header"><div className="card-title"></div></div> */}
                    <div>
                    
                      <form onSubmit={this.onSubmit}>
                        <center><span id="feeding_info_error" style={{color:"#ff0000", fontSize:"0.9em"}}>{ReactHtmlParser(this.state.feeding_info_error)}</span></center>
                        <div className="form-group">
                          <div id="breast_feeding" style={{border: "1px solid #d3d3d3",backgroundColor: "#d3d3d3",padding: "10px 0px",paddingLeft: "4px"}}>
                            {translation['feeding_practice_breastfeed_label']} <span className="px-1" onClick = {this.onBreastFed} style={{border: "2px solid hsl(120, 50%, 40%)",marginLeft:"2px",fontSize: "1em",backgroundColor: "hsl(120, 50%, 40%)",color: "#fff",borderRadius:"50%",paddingBottom:"1px"}}><FaPlus/></span>
                          </div>
                          <div style={{border: "1px solid #d3d3d3",height: "auto",padding: "10px 0px",borderBottom: "0px"}}>
                            <div className="row">		
                              <div id="breast_feeding_val" style={{width: "67%",paddingLeft: "20px"}}>
                                <input type="hidden" id="breast_feeding_input" name="breast_feeding_input" value="" readonly="readonly" />
                                {this.state.feeding_options.breast_feeding}
                              </div>
                              <span id="breast_feeding_error" style={{color:"#ff0000", fontSize:"0.9em"}}>{ReactHtmlParser(this.state.breast_feeding_error)}</span>
                              <div id="breast_frequency_val" className="col-xs-4" style = {{width: "33%",float: "right", paddingRight: "20px"}}>
                                {this.state.feeding_options.breast_frequency}
                              </div>
                              <span id="breast_frequency_error" style={{color:"#ff0000", fontSize:"0.9em"}}>{ReactHtmlParser(this.state.breast_frequency_error)}</span>
                            </div>
                          </div>
                        </div>
                        <div className="form-group">
                          <div id="complementary_feeding" style={{border: "1px solid #d3d3d3",backgroundColor: "#d3d3d3",padding: "4px",margin: "0px"}}>
                            {translation['feeding_practice_mealfeed_label']} <span className="px-1" onClick = {this.onMealFed} style={{border: "2px solid hsl(120, 50%, 40%)",marginLeft:"2px",fontSize: "1em",backgroundColor: "hsl(120, 50%, 40%)",color: "#fff",borderRadius:"50%",paddingBottom:"1px"}}><FaPlus/></span>
                          </div>
                          <div style={{border: "1px solid #d3d3d3",height: "auto",padding: "10px",borderBottom: "0px"}}>
                            <div className="row">
                              <div id="feeding_food_option_val" style = {{width: "25%",paddingLeft: "10px"}}>
                                <input type="hidden" id="feeding_food_option_input" name="feeding_food_option_input" value="" readonly="readonly" />
                                {this.state.feeding_options.meal_feeding}
                              </div>
                              <span id="meal_feeding_error" style={{color:"#ff0000", fontSize:"0.9em"}}>{ReactHtmlParser(this.state.meal_feeding_error)}</span>
                              <div id="feeding_food_val" style = {{width: "75%",paddingLeft: "30px",float: "right"}}>
                                {this.state.meal_food_list}
                              </div>
                              <span id="feeding_error" style={{color:"#ff0000", fontSize:"0.9em"}}>{ReactHtmlParser(this.state.feeding_error)}</span>
                            </div>
                          </div>
                        </div>
                        <div id="post1">
                          <button type="button" id="click" onClick={this.onSubmit} style={{float: "right",marginRight: "30px",width: "100px",height: "35px",marginBottom: "5px",backgroundColor: "hsl(120, 50%, 40%)",color: "#fff"}}>{translation['feeding_practice_next_button']}</button>
                        </div>
                    </form>
                    </div>
                
                  </div>
                </div>
            </div>
            </body>
            {this.state.breastFedModal ? (
              <BreastFedModal
                toggle={this.onBreastFed}
                onSave={this.onBreastFrequencySave}
                translation = {translation}
                Child = {Child}
              />
            ) : null}
            {this.state.mealFedModal ? (
              <MealFedModal
                toggle={this.onMealFed}
                onSave={this.onMealFoodListSave}
                translation = {translation}
                Child = {Child}
              />
            ) : null}
          </div>
        ): (
          <Menu showFeedingInst= {this.props.showFeedingInst} showTitle= {this.props.showTitle} food_list = {this.state.meal_menu} feeding_options = {this.state.feeding_options} Translator = {Translator} Child = {Child} User = {User} age = {age} onlyBreastFed = {this.state.onlyBreastFed} />
        )};
      </div>
    );
  }
}

export default FeedingForm;